import {
  GET_PROGRAMS,
  ADD_PROGRAM,
  DELETE_PROGRAM,
  UPDATE_PROGRAM,
  PROGRAMS_LOADING
} from '../actions/types';

const initialState = {
  programs: [],
  loading: false
};

export default function(state = initialState, action) {
  switch (action.type) {
    case GET_PROGRAMS:
      return { ...state, programs: action.payload, loading: false };
    case ADD_PROGRAM:
      return { ...state, programs: [action.payload, ...state.programs] };
    case UPDATE_PROGRAM:
      return {
        ...state,
        programs: state.programs.map(program =>
          program._id === action.payload._id ? action.payload : program
        )
      };
    case DELETE_PROGRAM:
      return {
        ...state,
        programs: state.programs.filter(program => program._id !== action.payload)
      };
    case PROGRAMS_LOADING:
      return { ...state, loading: true };
    default:
      return state;
  }
}
